export default "__VITE_ASSET__GFpFMdqk__"